import { Component, OnInit } from '@angular/core';
import { FormArray, FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ToastrService } from 'ngx-toastr';
import { GenericService } from 'src/app/services/generic.service';

@Component({
  selector: 'app-add-predefined-parameter',
  templateUrl: './add-predefined-parameter.component.html',
  styleUrls: ['./add-predefined-parameter.component.css']
})
export class AddPredefinedParameterComponent implements OnInit {

  form: any | FormGroup
  paramData:any = []
  page: number = 1;
  count: number = 0;
  tableSize: number = 10;
  tableSizes: any = [3, 6, 9, 12];
  singleParam:any = []
  cid:any
  formSubmit = false;

  paramTypes = [
    "USERPARAMS",
    "CUSTREG",
    "ADMIN",
    'MDPARAMS',
    'USERTYPE',
    'PRODUCTPARAMS',
    "TICKETPARAM",
    "TASKPARAM",
    "PROSPECT"
  ]

  type = [
    "Input",
    "Checkbox",
    "File",
    "Image",
    "Dropdown"
  ]

  constructor(private fb: FormBuilder,private toastr: ToastrService,private generic_service: GenericService) { }

  ngOnInit(): void {
    this.cid = sessionStorage.getItem('cid')
    this.getParamsData()
    this.form = this.fb.group({
      name: ['',[Validators.required]],
      type: ['',[Validators.required]],
      isMandatory: [''],
      boxType: [''],
      possibleValue:this.fb.array([])
    }) 
    this.addpossibleValue()
  }

  onTableDataChange(event: any) {
    this.page = event;
    this.getParamsData();
  }

  onTableSizeChange(event: any): void {
    this.tableSize = event.target.value;
    this.page = 1;
    this.getParamsData();
  }

  get paramArr(){
    return this.form.get('possibleValue') as FormArray;
  }

  possibleValue(){
    return this.fb.group({
      "key":['']
    })
  }
  addpossibleValue(){
    this.paramArr.push(this.possibleValue())
  }
  
  removepossibleValue(index: number){
    this.paramArr.removeAt(index)
  }

  addParam(){

    this.formSubmit = true;
    if(!this.form.valid){
      console.log(this.form.value)
      return
    }

    let arr = []
     arr = this.form.get('possibleValue').value
      let possible = []
      for(var i = 0; arr.length > i;i++){
        if(arr[i].key != ""){
          possible.push(arr[i].key)
        }
      }
      let body = {
          "version": 0,
          "isActive": true,
          "description": "string",
          "name": String(this.form.get('name').value),
          "type": String(this.form.get('type').value),
          "possibleValue": possible,
          "cid": this.cid
        }

    console.log(body)
    this.generic_service.addParam(body).subscribe(
      (response:any)=>{
        console.log(response)
        this.getParamsData()
        this.toastr.success(response.message);
        this.cancelModel()
        this.formSubmit = false;
        this.form.reset()
      },
      (err:any)=>{
        console.log(err)
        this.toastr.error(err.error.errors[0].description);
      },
    )
  }

  cancelModel(){
    document.getElementById("closeModalButton")?.click()
    document.getElementById("closeModalButton1")?.click()
  }

  getParamsData(){
    this.generic_service.getParams().subscribe(
      (res:any)=> {
        console.log(res)
        this.paramData = res.response
      },
      (err:any)=>{
        console.log(err)
      }
    )
  }

  getParamById(id:any){
    console.log(id)
    this.generic_service.getParamById(id).subscribe(
      (res:any)=>{
        this.singleParam = []
        this.singleParam.push(res.response)
      }
    )
  }

  boxTypeChange(){
    
  }

}